import { z } from 'zod';

export const ModalSessionCorporateSelectionSchema = z
  .object({
    companyId: z.string().min(1),
    costCenterId: z.string().min(1),
    motiveId: z.string().min(1).optional(),
    projectId: z.string().min(1).optional(),
    justificationId: z.string().min(1).optional(),
  })
  .strict();
export type ModalSessionCorporateSelection = z.infer<typeof ModalSessionCorporateSelectionSchema>;

/** Solicitante como o chamador o conhece. Só o MICE manda: o booking roda no workspace do
 *  evento, onde um solicitante de outro cliente não existe e o approval volta sem `user`. */
export const ModalSessionBookingRequesterSchema = z
  .object({
    name: z.string().trim().min(1).optional(),
    email: z.string().trim().min(1).optional(),
  })
  .strict();
export type ModalSessionBookingRequester = z.infer<typeof ModalSessionBookingRequesterSchema>;
